/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc
 */
import * as References from './DashworksRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#fetchAppParams
 */
export const FETCH_APP_PARAMS_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_fetchAppParams';
export const FETCH_APP_PARAMS_QUERY: RegisteredQuery<
  'result',
  References.FetchAppParamsRequestType,
  References.FetchAppParamsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_APP_PARAMS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.FetchAppParamsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchAppParamsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchAppParamsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#storeUserAppSecret
 */
export const STORE_USER_APP_SECRET_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_storeUserAppSecret';
export const STORE_USER_APP_SECRET_QUERY: RegisteredQuery<
  'result',
  References.StoreUserAppSecretRequestType,
  References.StoreUserAppSecretResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: STORE_USER_APP_SECRET_QUERY_FIELD_NAME,
  args: ['appId', 'secretId', 'authenticatorId', 'userScope'],
  fetcher(
    request: References.StoreUserAppSecretRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.StoreUserAppSecretResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.storeUserAppSecretRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getAppIds
 */
export const GET_APP_IDS_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_getAppIds';
export const GET_APP_IDS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAppIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_IDS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getAppIdsRpc, {
      timeout: ctx.timeout,
      request: {},
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getBreezeConnectorAppIds
 */
export const GET_BREEZE_CONNECTOR_APP_IDS_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_getBreezeConnectorAppIds';
export const GET_BREEZE_CONNECTOR_APP_IDS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetBreezeConnectorAppIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BREEZE_CONNECTOR_APP_IDS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBreezeConnectorAppIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBreezeConnectorAppIdsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getUserConnectedApps
 */
export const GET_USER_CONNECTED_APPS_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_getUserConnectedApps';
export const GET_USER_CONNECTED_APPS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetUserConnectedAppsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_CONNECTED_APPS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserConnectedAppsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserConnectedAppsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getMcpServersByIds
 */
export const GET_MCP_SERVERS_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_getMcpServersByIds';
export const GET_MCP_SERVERS_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServersByIdsRequestType,
  References.GetMcpServersByIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_BY_IDS_QUERY_FIELD_NAME,
  args: ['mcpServerIds'],
  fetcher(
    request: References.GetMcpServersByIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersByIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServersByIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#disconnectUserApp
 */
export const DISCONNECT_USER_APP_MUTATION_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_disconnectUserApp';
export const DISCONNECT_USER_APP_MUTATION: RegisteredQuery<
  'result',
  References.DisconnectUserAppRequestType,
  References.DisconnectUserAppResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DISCONNECT_USER_APP_MUTATION_FIELD_NAME,
  args: ['appId', 'deleteOption'],
  fetcher(
    request: References.DisconnectUserAppRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DisconnectUserAppResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.disconnectUserAppRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#testGimmieSetup
 */
export const TEST_GIMMIE_SETUP_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_testGimmieSetup';
export const TEST_GIMMIE_SETUP_QUERY: RegisteredQuery<
  'result',
  References.TestGimmieSetupRequestType,
  References.TestGimmieSetupResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: TEST_GIMMIE_SETUP_QUERY_FIELD_NAME,
  args: ['appNames', 'appNamespace', 'sourcePortalId'],
  fetcher(
    request: References.TestGimmieSetupRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.TestGimmieSetupResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.testGimmieSetupRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#testGimmieCleanup
 */
export const TEST_GIMMIE_CLEANUP_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_testGimmieCleanup';
export const TEST_GIMMIE_CLEANUP_QUERY: RegisteredQuery<
  'result',
  References.TestGimmieCleanupRequestType,
  References.TestGimmieCleanupResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: TEST_GIMMIE_CLEANUP_QUERY_FIELD_NAME,
  args: ['appNames', 'appNamespace'],
  fetcher(
    request: References.TestGimmieCleanupRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.TestGimmieCleanupResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.testGimmieCleanupRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEvalSingle
 */
export const RUN_RETRIEVAL_EVAL_SINGLE_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEvalSingle';
export const RUN_RETRIEVAL_EVAL_SINGLE_QUERY: RegisteredQuery<
  'result',
  References.RunRetrievalEvalSingleRequestType,
  References.RunRetrievalEvalSingleResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_SINGLE_QUERY_FIELD_NAME,
  args: ['query', 'goldenDocumentId', 'appName'],
  fetcher(
    request: References.RunRetrievalEvalSingleRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RunRetrievalEvalSingleResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.runRetrievalEvalSingleRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEval
 */
export const RUN_RETRIEVAL_EVAL_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEval';
export const RUN_RETRIEVAL_EVAL_QUERY: RegisteredQuery<
  'result',
  References.RunRetrievalEvalRequestType,
  References.RunRetrievalEvalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_QUERY_FIELD_NAME,
  args: ['queries', 'appNames'],
  fetcher(
    request: References.RunRetrievalEvalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RunRetrievalEvalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.runRetrievalEvalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEvalFromGoogleSheet
 */
export const RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY_FIELD_NAME =
  'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEvalFromGoogleSheet';
export const RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY: RegisteredQuery<
  'result',
  References.RunRetrievalEvalFromGoogleSheetRequestType,
  References.RunRetrievalEvalFromGoogleSheetResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY_FIELD_NAME,
  args: ['spreadsheetUrl', 'appName'],
  fetcher(
    request: References.RunRetrievalEvalFromGoogleSheetRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RunRetrievalEvalFromGoogleSheetResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.runRetrievalEvalFromGoogleSheetRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
